import * as React from 'react';
import Section from '../section/Section';

import './style.css';
import '../../assets/style.css';

import logo from '../../assets/logo/logo.png'
import hash from '../../assets/logo/hash.png'
import { LocationOn, Mail, Phone } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import {isBrowser, isMobile } from 'react-device-detect'
export default function Footer(){
    return(
        <div id="footer" className="background-white" style={{borderTop:"7px double black"}}>   
            <Section 
            content={
                <>
            <div className={isMobile?"flex-column flex-centered":"flex-row flex-centered"} style={{width:"80%", textAlign:"center", margin:"auto", padding:"2rem", fontSize:"1rem", gap:"20%", justifyContent:"space-around"}}>
             <div className='footer-logo'> <Link className='footer-logo' to="https://psihologija.hr"><div className='footer-logo'></div></Link>  </div>
               <div className="hashtag"></div> 
            </div>
            </>
            
            }/>
            .</div>
        
    )   
}